import { useState } from "react";
import { useToast } from "@chakra-ui/react";
import API_CONFIG from "Configuration/apiConfig";

export function useRecalculation({ 
  getRunId,        
  getStoreId,      
  onSuccess,       
}) {
  const [isRecalculating, setIsRecalculating] = useState(false);
  const toast = useToast();

  const handleRecalculation = async () => {
    const runId   = getRunId();
    const storeId = getStoreId();

    if (!runId || !storeId) {
      toast({
        title: "Missing Data",
        description: "Missing runId or storeId.",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
      return;
    }
    setIsRecalculating(true);
    try {
      const query    = new URLSearchParams({ runId, storeId }).toString();
      const response = await fetch(
        `${API_CONFIG.RECALCULATION_BASE_URL}${API_CONFIG.ENDPOINTS.STORE_REPORT.RECALCULATION}?${query}`
      );
      if (!response.ok) throw new Error("API failed");
      await response.text();

      toast({
        title: "Success",
        description: "Stores Calculated Successfully",
        status: "success",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    } catch (error) {
      console.error(error);
      toast({
        title: "Error",
        description: "Recalculation failed",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
      setIsRecalculating(false);
      return;
    }
    setIsRecalculating(false);

    if (onSuccess) {
      try {
        await onSuccess();
      } catch (err) {
        console.error("Post-recalculation refresh failed:", err);
      }
    }
  };

  return { handleRecalculation, isRecalculating };
}